import React, { Component } from 'react';
import Slider from "react-slick";
import logo from '../assets/logo-ksb.png';
import LoginForm from "../components/LoginForm";

import bgBrander from '../assets/bg-brander.png';
import bgSeller from '../assets/bg-seller.png';

/**
 * 登录页面
 */
class LoginPage extends Component {

  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 1000,
      autoplaySpeed: 6000,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: false,
      nextArrow: undefined,
      prevArrow: undefined
    };
    const year = new Date().getFullYear();
    return (
      <div style={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}>
        <div style={{width: '100%', height: 60, zIndex: 99999, backgroundColor: 'white'}}>
          <img src={logo} height={40} alt='' style={{marginLeft: window.innerWidth * 0.1, marginTop: 10}}/>
        </div>
        <Slider {...settings}>
          <img style={{width: '100%', height: 'calc(100% - 60px)', overflow: 'hidden'}} src={bgBrander} alt={''}/>
          <img style={{width: '100%', height: 'calc(100% - 60px)', overflow: 'hidden'}} src={bgSeller} alt={''}/>
        </Slider>
        <div style={{
          position: 'absolute',
          zIndex: 99,
          top: '60px',
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 80,
        }}>
          <LoginForm/>
        </div>
        {/*备案*/}
        <div style={{
          position: 'absolute',
          bottom: 6,
          left: 0,
          right: 0,
          textAlign: 'center',
          fontSize: 10,
          color: '#666'
        }}>
          Copyright 2017 - {year} Moresales. All Rights Reserved &nbsp;&nbsp;
          <a href="https://beian.miit.gov.cn/#/Integrated/index"
             style={{color: '#aaa'}}>粤ICP备17124279号-1</a>
        </div>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js